<template>
  <PostSearchResultList
    :posts="posts"
    @clicked="handleClick"
    :columns="2"
  />
</template>

<script>
  import PostSearchResultList from '@/components/search/posts/PostSearchResultList';

  export default {
    props: {
      posts: {
        type: [],
        default: [],
        required: true
      },
    },
    components: {
      PostSearchResultList,
    },
    methods: {
      handleClick: function(post) {
        let route = {
          name: 'search-guidelines-detail',
          params: {
            id: post.id
          }
        }

        if (this.$route.query.q || this.$route.query.t) {
          route.query = {
            q: this.$route.query.q,
            t: this.$route.query.t
          }
        }

        this.$router.push(route);
      }
    }
  }
</script>
